import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	h3 {
		color: #000;
		font-size: 14px;
		font-weight: 700;
	}
	p {
		color: var(--default-text-color);
		font-size: 15px;
		font-weight: 600;
	}
`;

interface FeedBackMessageProps {
	feedBackData: any;
}

const FeedBackMessage: React.FC<FeedBackMessageProps> = ({ feedBackData }) => {
	return (
		<Container>
			<h3>Order#{feedBackData?.orderId} Feedback</h3>
			<p>{feedBackData?.feedback}</p>
		</Container>
	);
};

export default FeedBackMessage;
